import React from "react";
import { bindActionCreators } from "redux";
import specials from "modules/specials";
import { connect } from "react-redux";

import "./AfishaSearchInfo.css";

const AfishaSearchInfo = ({
  dates,
  timeInterval,
  total_items,
  requests,
  query,
  resetSpecials,
  reset,
  onScrollToTop,
  isPartnerSelected,
  isSpecialOffersSelected
}) => {
  const isThereAreChanges =
    requests.length ||
    dates.length === 1 ||
    query ||
    isPartnerSelected ||
    isSpecialOffersSelected;

  return (
    <div className="afisha-search-info-container">
      <div className="afisha-search_results-container__info">
        <p>
          Найдено <span>{total_items}</span> мероприятия
        </p>
        <div className="afisha__card-date">
          {dates.length !== 1 ? (
            <p className="afisha__card-date_dates">Все дни</p>
          ) : (
            <p className="afisha__card-date_dates">{dates[0]}</p>
          )}
          <p>
            {timeInterval[0]}–{timeInterval[1]}
          </p>
        </div>
        {requests.length ? (
          requests.map((item, i) => (
            <p className="selected-types" key={i}>
              {item}
            </p>
          ))
        ) : (
          <p className="selected-types">Все читальни</p>
        )}
        {isPartnerSelected && <p className="selected-types">Партнёры</p>}
        {isSpecialOffersSelected && (
          <p className="selected-types">Спецпредложения</p>
        )}
        {query && <p className="selected-types">{query}</p>}
        {isThereAreChanges && (
          <button onClick={() => !reset && resetSpecials()}>
            Изменить параметры поиска
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.0173 2.94629L7.07107 5.89256L4.12479 2.94629L2.94628 4.1248L5.89256 7.07108L2.94628 10.0174L4.12479 11.1959L7.07107 8.24959L10.0173 11.1959L11.1959 10.0174L8.24958 7.07108L11.1959 4.1248L10.0173 2.94629Z"
                fill="#2B2B2B"
              />
            </svg>
          </button>
        )}
      </div>
      <div onClick={() => onScrollToTop()} className="afisha-scroll">
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="50" height="50" rx="5" fill="#E9E9F0" />
          <path
            d="M25.7071 14.2929C25.3166 13.9024 24.6834 13.9024 24.2929 14.2929L17.9289 20.6569C17.5384 21.0474 17.5384 21.6805 17.9289 22.0711C18.3195 22.4616 18.9526 22.4616 19.3431 22.0711L25 16.4142L30.6569 22.0711C31.0474 22.4616 31.6805 22.4616 32.0711 22.0711C32.4616 21.6805 32.4616 21.0474 32.0711 20.6569L25.7071 14.2929ZM26 35L26 15L24 15L24 35L26 35Z"
            fill="#26587C"
          />
        </svg>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  reset: state.specials.reset
});

const mapDispatchToProps = dispatch => ({
  resetSpecials: bindActionCreators(specials.actions.resetSpecials, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AfishaSearchInfo);



// WEBPACK FOOTER //
// ./src/components/Events/AfishaSearchInfo.js